import React, { Suspense, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";

import WebMenu from "../Pages/Shared/WebMenu";
import Footer from "../Pages/Shared/Footer";

function PublicRoute() {
  const pathname = useLocation();
  const accessToken = useSelector(
    (state) => state.login?.LoginDetails?.accessToken
  );

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);

  // if (accessToken) {
  //   return <Navigate to="/dashboard" replace />;
  // }

  return (
    <>
      <WebMenu />

      <Suspense
        fallback={
          <div className="loader">
            <CircularProgress sx={{ color: "#86c65a" }} />
          </div>
        }
      >
        <Outlet />
      </Suspense>

      <Footer />
    </>
  );
}

export default PublicRoute;
